import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mapHorizontalControlBar');

    return {
        CLOSE: t('close'),
        DRAW: t('draw')
    };
};

export default useTranslation;
